import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';

import UserRole from '@careerstart/wae-common/src/main/constants/user-role';
import { Box } from '@mui/material';

import launchDarklyToggles, {
  DARKLY_TOGGLE_NAMES,
} from '../../../../main-deprecated/utils/launchDarklyToggles';
import selectUser from '../../../store/selectors/appSelector';
import {
  selectTaxCreditOpportunities,
  selectUserDetail,
} from '../../../store/selectors/userListSelector';
import { USER_STATUS } from '../UsersConstants';

import EmployeeDocumentation from './components/workerComponents/EmployeeDocumentation';
import TaxCreditsCard from './components/workerComponents/TaxCreditsCard';
import UserAccountActivationToggle from './components/workerComponents/UserAccountActivationToggle';
import { USER_ACCOUNT_ACTIVATION_TOGGLE_MODES } from './components/workerComponents/UserAccountActivationToggle/userAccountActivationToggleConfig';
import WAEOnboardingStatusCard from './components/workerComponents/WAEOnboardingStatusCard';
import WorkExperienceCard from './components/workerComponents/WorkExperienceCard';
import WorkPreferencesCard from './components/workerComponents/WorkPreferenceCard';
import UserDetailCardView from './userDetailCards/UserDetailCardView';

const UserDetailLeft = () => {
  const selectedUser = useSelector(selectUserDetail)?.[0];
  const user = useSelector(selectUser);
  const taxCreditOpportunities = useSelector(selectTaxCreditOpportunities);
  const flags = useFlags();
  const isUserAdmin = user?.role === UserRole.ADMIN;
  const isUserDetailsDocumentsViewerEnabled = launchDarklyToggles(
    flags,
    DARKLY_TOGGLE_NAMES.hb5096WebEnableUserDetailsDocumentsViewer
  );

  const isUserDeactivated = selectedUser?.status === USER_STATUS.DEACTIVATED;

  const preference = {
    distance: selectedUser?.candidate?.distance,
    preferredShiftTimes: selectedUser?.candidate?.preferredShiftTimes,
    minPay: selectedUser?.candidate?.minPay,
    desiredWeeklyHours: selectedUser?.candidate?.desiredWeeklyHours,
  };

  const hasAnyPreferenceValue =
    preference &&
    (preference.desiredWeeklyHours !== undefined ||
      preference.distance !== undefined ||
      preference.minPay !== undefined ||
      preference.preferredShiftTimes !== undefined);

  const onboardingDoc = selectedUser?.candidate?.onboardingDoc;
  const eVerify = selectedUser?.candidate?.eVerify;
  // Sage's own state, kept separate from the eVerify admin stamp above.
  const sageId = selectedUser?.candidate?.sageId;
  const sageEVerify = selectedUser?.candidate?.sageEVerify;
  const selectedUserId = selectedUser?.id;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      {selectedUser && <UserDetailCardView selectedUser={selectedUser} isEditable={isUserAdmin} />}
      {selectedUser?.role === UserRole.CANDIDATE && (
        <Box>
          {user?.role === UserRole.ADMIN && (
            <>
              <WAEOnboardingStatusCard
                onboardingDoc={onboardingDoc}
                eVerify={eVerify}
                sageId={sageId}
                sageEVerify={sageEVerify}
                selectedUserId={selectedUserId}
              />
              <TaxCreditsCard
                taxCreditOpportunities={taxCreditOpportunities}
                selectedUserId={selectedUserId}
              />
            </>
          )}
          <WorkExperienceCard
            industries={selectedUser?.candidate?.industry}
            selectedUserId={selectedUserId}
          />
          {hasAnyPreferenceValue && <WorkPreferencesCard preference={preference} />}
          {isUserDetailsDocumentsViewerEnabled && <EmployeeDocumentation />}
        </Box>
      )}
      {user?.role === UserRole.ADMIN && (
        <UserAccountActivationToggle
          userId={selectedUser?.id}
          mode={
            isUserDeactivated
              ? USER_ACCOUNT_ACTIVATION_TOGGLE_MODES.ACTIVATE
              : USER_ACCOUNT_ACTIVATION_TOGGLE_MODES.DEACTIVATE
          }
        />
      )}
    </Box>
  );
};

export default UserDetailLeft;
